import React, { useState, useEffect, useRef } from 'react';
import validator from 'validator';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

// EmailJS Configuration
const EMAILJS_SERVICE_ID = 'service_diokqlu';
const EMAILJS_TEMPLATE_ID = 'template_ybwsnwn';
const EMAILJS_PUBLIC_KEY = 'iePcz8OwME3__OISj';

function Contact() {
  const [nome, setNome] = useState('');
  const [mail, setMail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!(nome && mail && mensagem)) {
      toast.warning('Fill in all fields.');
      return;
    }

    if (!validator.isEmail(mail)) {
      toast.warning('E-mail invalid');
      return;
    }

    setLoading(true);

    const templateParams = {
      from_name: nome,
      from_email: mail,
      message: mensagem,
    };

    emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setNome('');
        setMail('');
        setMensagem('');
        toast.success("Thanks for writing. I'll answer as soon as possible.");
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        toast.error('There was an error sending the email. Please try again later.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section 
      id="contact" 
      ref={sectionRef}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 50, 70, 0.35), rgba(0, 50, 70, 0.4)), url(${process.env.PUBLIC_URL}/images/header-background3.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: '0% 25%',
        minHeight: '700px',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }}
    >
      <div className="row section-head">
        <div className="twelve columns">
          <h1>
            Please fill in the box below to contact me.
          </h1>
        </div>
      </div>

      <div className="row">
        <div className="twelve columns main-col">
          <form onSubmit={handleSubmit}>
            <fieldset>
              <div>
                <label htmlFor="name">
                  Name <span className="required">*</span>
                </label>
                <input
                  id="name"
                  type="text"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="email">
                  E-mail <span className="required">*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                />
              </div>

              <div>
                <label htmlFor="message">
                  Message <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  value={mensagem}
                  onChange={(e) => setMensagem(e.target.value)}
                />
              </div>

              <div>
                <button 
                  type="submit"
                  className="submit" 
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Submit'}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
